/* eslint-disable */
// @ts-nocheck
// source: internal/inventory_item.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js');
goog.object.extend(proto, google_api_field_behavior_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_protobuf_field_mask_pb = require('google-protobuf/google/protobuf/field_mask_pb.js');
goog.object.extend(proto, google_protobuf_field_mask_pb);
var shared_types_decimal_pb = require('../shared/types/decimal_pb.js');
goog.object.extend(proto, shared_types_decimal_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.worklayer.internal.v1.ArchiveInventoryItemRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ArchiveInventoryItemResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CreateInventoryItemRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CreateInventoryItemResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetInventoryItemError', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetManyInventoryItem', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetManyInventoryItem.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetManyInventoryItemsErrorType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetManyInventoryItemsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetManyInventoryItemsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ImportInventoryItemResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ImportInventoryItemsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ImportedInventoryItemResult', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItem', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemDocumentSignature', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemForProviders', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemJobProgressionEssential', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemJobProgressionRetail', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemJobProgressionReview', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemPriceType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemProVisibility', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemSupportingItem', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemTypeSpecification', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.ExtensionBillingType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.ExtensionType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InventoryItemUpdateOptions', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListInventoryItemsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListInventoryItemsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProgressionStepBillingValues', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetProVisibilityRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetProVisibilityResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.UnarchiveInventoryItemRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.UnarchiveInventoryItemResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.UpdateInventoryItemRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.UpdateInventoryItemResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.WorkspaceWithInventoryItems', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ImportInventoryItemsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ImportInventoryItemsRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ImportInventoryItemsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ImportInventoryItemsRequest.displayName = 'proto.worklayer.internal.v1.ImportInventoryItemsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ImportInventoryItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ImportInventoryItemResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ImportInventoryItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ImportInventoryItemResponse.displayName = 'proto.worklayer.internal.v1.ImportInventoryItemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ImportedInventoryItemResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ImportedInventoryItemResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ImportedInventoryItemResult.displayName = 'proto.worklayer.internal.v1.ImportedInventoryItemResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.GetManyInventoryItemsRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.GetManyInventoryItemsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetManyInventoryItemsRequest.displayName = 'proto.worklayer.internal.v1.GetManyInventoryItemsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetManyInventoryItemsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.GetManyInventoryItemsResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.GetManyInventoryItemsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetManyInventoryItemsResponse.displayName = 'proto.worklayer.internal.v1.GetManyInventoryItemsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetManyInventoryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.GetManyInventoryItem.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.GetManyInventoryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetManyInventoryItem.displayName = 'proto.worklayer.internal.v1.GetManyInventoryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetInventoryItemError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.GetInventoryItemError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetInventoryItemError.displayName = 'proto.worklayer.internal.v1.GetInventoryItemError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.CreateInventoryItemRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.CreateInventoryItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CreateInventoryItemRequest.displayName = 'proto.worklayer.internal.v1.CreateInventoryItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.UpdateInventoryItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.UpdateInventoryItemRequest.displayName = 'proto.worklayer.internal.v1.UpdateInventoryItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CreateInventoryItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.CreateInventoryItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CreateInventoryItemResponse.displayName = 'proto.worklayer.internal.v1.CreateInventoryItemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.UpdateInventoryItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.UpdateInventoryItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.UpdateInventoryItemResponse.displayName = 'proto.worklayer.internal.v1.UpdateInventoryItemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.InventoryItemUpdateOptions.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemUpdateOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemUpdateOptions.displayName = 'proto.worklayer.internal.v1.InventoryItemUpdateOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListInventoryItemsRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListInventoryItemsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListInventoryItemsRequest.displayName = 'proto.worklayer.internal.v1.ListInventoryItemsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListInventoryItemsResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListInventoryItemsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListInventoryItemsResponse.displayName = 'proto.worklayer.internal.v1.ListInventoryItemsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.displayName = 'proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.displayName = 'proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.InventoryItem.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItem.displayName = 'proto.worklayer.internal.v1.InventoryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemSupportingItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemSupportingItem.displayName = 'proto.worklayer.internal.v1.InventoryItemSupportingItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.displayName = 'proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.displayName = 'proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo.displayName = 'proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo.displayName = 'proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo.displayName = 'proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod.displayName = 'proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo.displayName = 'proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod.displayName = 'proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes.displayName = 'proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemDocumentSignature = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemDocumentSignature, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemDocumentSignature.displayName = 'proto.worklayer.internal.v1.InventoryItemDocumentSignature';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemTypeSpecification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.displayName = 'proto.worklayer.internal.v1.InventoryItemTypeSpecification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.displayName = 'proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.displayName = 'proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.displayName = 'proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.displayName = 'proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.displayName = 'proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.displayName = 'proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.displayName = 'proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.displayName = 'proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemForProviders = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemForProviders, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemForProviders.displayName = 'proto.worklayer.internal.v1.InventoryItemForProviders';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ArchiveInventoryItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ArchiveInventoryItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ArchiveInventoryItemRequest.displayName = 'proto.worklayer.internal.v1.ArchiveInventoryItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ArchiveInventoryItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ArchiveInventoryItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ArchiveInventoryItemResponse.displayName = 'proto.worklayer.internal.v1.ArchiveInventoryItemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.UnarchiveInventoryItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.UnarchiveInventoryItemRequest.displayName = 'proto.worklayer.internal.v1.UnarchiveInventoryItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.UnarchiveInventoryItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.displayName = 'proto.worklayer.internal.v1.UnarchiveInventoryItemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetProVisibilityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetProVisibilityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetProVisibilityRequest.displayName = 'proto.worklayer.internal.v1.SetProVisibilityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetProVisibilityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetProVisibilityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetProVisibilityResponse.displayName = 'proto.worklayer.internal.v1.SetProVisibilityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.WorkspaceWithInventoryItems = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.WorkspaceWithInventoryItems, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.WorkspaceWithInventoryItems.displayName = 'proto.worklayer.internal.v1.WorkspaceWithInventoryItems';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest.displayName = 'proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.displayName = 'proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.displayName = 'proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.displayName = 'proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemJobProgressionRetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.displayName = 'proto.worklayer.internal.v1.InventoryItemJobProgressionRetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemJobProgressionEssential, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.displayName = 'proto.worklayer.internal.v1.InventoryItemJobProgressionEssential';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.displayName = 'proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.InventoryItemJobProgressionReview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InventoryItemJobProgressionReview.displayName = 'proto.worklayer.internal.v1.InventoryItemJobProgressionReview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProgressionStepBillingValues = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProgressionStepBillingValues, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProgressionStepBillingValues.displayName = 'proto.worklayer.internal.v1.ProgressionStepBillingValues';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ImportInventoryItemsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ImportInventoryItemsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ImportInventoryItemsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ImportInventoryItemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ImportInventoryItemsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsToImportList: jspb.Message.toObjectList(msg.getItemsToImportList(),
    proto.worklayer.internal.v1.InventoryItem.toObject, includeInstance),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ImportInventoryItemsRequest}
 */
proto.worklayer.internal.v1.ImportInventoryItemsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ImportInventoryItemsRequest;
  return proto.worklayer.internal.v1.ImportInventoryItemsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ImportInventoryItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ImportInventoryItemsRequest}
 */
proto.worklayer.internal.v1.ImportInventoryItemsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.InventoryItem;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItem.deserializeBinaryFromReader);
      msg.addItemsToImport(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ImportInventoryItemsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ImportInventoryItemsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ImportInventoryItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ImportInventoryItemsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsToImportList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.InventoryItem.serializeBinaryToWriter
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated InventoryItem items_to_import = 1;
 * @return {!Array<!proto.worklayer.internal.v1.InventoryItem>}
 */
proto.worklayer.internal.v1.ImportInventoryItemsRequest.prototype.getItemsToImportList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.InventoryItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.InventoryItem, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.InventoryItem>} value
 * @return {!proto.worklayer.internal.v1.ImportInventoryItemsRequest} returns this
*/
proto.worklayer.internal.v1.ImportInventoryItemsRequest.prototype.setItemsToImportList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.InventoryItem}
 */
proto.worklayer.internal.v1.ImportInventoryItemsRequest.prototype.addItemsToImport = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.InventoryItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ImportInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.ImportInventoryItemsRequest.prototype.clearItemsToImportList = function() {
  return this.setItemsToImportList([]);
};


/**
 * optional string workspace_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ImportInventoryItemsRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ImportInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.ImportInventoryItemsRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ImportInventoryItemResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ImportInventoryItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ImportInventoryItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ImportInventoryItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ImportInventoryItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    newItemsList: jspb.Message.toObjectList(msg.getNewItemsList(),
    proto.worklayer.internal.v1.ImportedInventoryItemResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ImportInventoryItemResponse}
 */
proto.worklayer.internal.v1.ImportInventoryItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ImportInventoryItemResponse;
  return proto.worklayer.internal.v1.ImportInventoryItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ImportInventoryItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ImportInventoryItemResponse}
 */
proto.worklayer.internal.v1.ImportInventoryItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.ImportedInventoryItemResult;
      reader.readMessage(value,proto.worklayer.internal.v1.ImportedInventoryItemResult.deserializeBinaryFromReader);
      msg.addNewItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ImportInventoryItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ImportInventoryItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ImportInventoryItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ImportInventoryItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.ImportedInventoryItemResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ImportedInventoryItemResult new_items = 1;
 * @return {!Array<!proto.worklayer.internal.v1.ImportedInventoryItemResult>}
 */
proto.worklayer.internal.v1.ImportInventoryItemResponse.prototype.getNewItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.ImportedInventoryItemResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.ImportedInventoryItemResult, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.ImportedInventoryItemResult>} value
 * @return {!proto.worklayer.internal.v1.ImportInventoryItemResponse} returns this
*/
proto.worklayer.internal.v1.ImportInventoryItemResponse.prototype.setNewItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.ImportedInventoryItemResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.ImportedInventoryItemResult}
 */
proto.worklayer.internal.v1.ImportInventoryItemResponse.prototype.addNewItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.ImportedInventoryItemResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ImportInventoryItemResponse} returns this
 */
proto.worklayer.internal.v1.ImportInventoryItemResponse.prototype.clearNewItemsList = function() {
  return this.setNewItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ImportedInventoryItemResult.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ImportedInventoryItemResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ImportedInventoryItemResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ImportedInventoryItemResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    previousItemId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    newItemId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ImportedInventoryItemResult}
 */
proto.worklayer.internal.v1.ImportedInventoryItemResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ImportedInventoryItemResult;
  return proto.worklayer.internal.v1.ImportedInventoryItemResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ImportedInventoryItemResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ImportedInventoryItemResult}
 */
proto.worklayer.internal.v1.ImportedInventoryItemResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousItemId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ImportedInventoryItemResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ImportedInventoryItemResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ImportedInventoryItemResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ImportedInventoryItemResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreviousItemId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNewItemId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string previous_item_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ImportedInventoryItemResult.prototype.getPreviousItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ImportedInventoryItemResult} returns this
 */
proto.worklayer.internal.v1.ImportedInventoryItemResult.prototype.setPreviousItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string new_item_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ImportedInventoryItemResult.prototype.getNewItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ImportedInventoryItemResult} returns this
 */
proto.worklayer.internal.v1.ImportedInventoryItemResult.prototype.setNewItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetManyInventoryItemsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetManyInventoryItemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    workspaceId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItemsRequest}
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetManyInventoryItemsRequest;
  return proto.worklayer.internal.v1.GetManyInventoryItemsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetManyInventoryItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItemsRequest}
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetManyInventoryItemsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetManyInventoryItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};


/**
 * optional string workspace_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.GetManyInventoryItemsRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.GetManyInventoryItemsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetManyInventoryItemsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetManyInventoryItemsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetManyInventoryItemsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetManyInventoryItemsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryItemsList: jspb.Message.toObjectList(msg.getInventoryItemsList(),
    proto.worklayer.internal.v1.GetManyInventoryItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItemsResponse}
 */
proto.worklayer.internal.v1.GetManyInventoryItemsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetManyInventoryItemsResponse;
  return proto.worklayer.internal.v1.GetManyInventoryItemsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetManyInventoryItemsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItemsResponse}
 */
proto.worklayer.internal.v1.GetManyInventoryItemsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.GetManyInventoryItem;
      reader.readMessage(value,proto.worklayer.internal.v1.GetManyInventoryItem.deserializeBinaryFromReader);
      msg.addInventoryItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetManyInventoryItemsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetManyInventoryItemsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetManyInventoryItemsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetManyInventoryItemsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.GetManyInventoryItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated GetManyInventoryItem inventory_items = 1;
 * @return {!Array<!proto.worklayer.internal.v1.GetManyInventoryItem>}
 */
proto.worklayer.internal.v1.GetManyInventoryItemsResponse.prototype.getInventoryItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.GetManyInventoryItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.GetManyInventoryItem, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.GetManyInventoryItem>} value
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItemsResponse} returns this
*/
proto.worklayer.internal.v1.GetManyInventoryItemsResponse.prototype.setInventoryItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.GetManyInventoryItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItem}
 */
proto.worklayer.internal.v1.GetManyInventoryItemsResponse.prototype.addInventoryItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.GetManyInventoryItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItemsResponse} returns this
 */
proto.worklayer.internal.v1.GetManyInventoryItemsResponse.prototype.clearInventoryItemsList = function() {
  return this.setInventoryItemsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.GetManyInventoryItem.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.GetManyInventoryItem.TypeCase = {
  TYPE_NOT_SET: 0,
  ITEM: 2,
  ERROR: 3
};

/**
 * @return {proto.worklayer.internal.v1.GetManyInventoryItem.TypeCase}
 */
proto.worklayer.internal.v1.GetManyInventoryItem.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.GetManyInventoryItem.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.GetManyInventoryItem.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetManyInventoryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetManyInventoryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetManyInventoryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetManyInventoryItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    item: (f = msg.getItem()) && proto.worklayer.internal.v1.InventoryItem.toObject(includeInstance, f),
    error: (f = msg.getError()) && proto.worklayer.internal.v1.GetInventoryItemError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItem}
 */
proto.worklayer.internal.v1.GetManyInventoryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetManyInventoryItem;
  return proto.worklayer.internal.v1.GetManyInventoryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetManyInventoryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItem}
 */
proto.worklayer.internal.v1.GetManyInventoryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.worklayer.internal.v1.InventoryItem;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItem.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.GetInventoryItemError;
      reader.readMessage(value,proto.worklayer.internal.v1.GetInventoryItemError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetManyInventoryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetManyInventoryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetManyInventoryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetManyInventoryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.InventoryItem.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.GetInventoryItemError.serializeBinaryToWriter
    );
  }
};


/**
 * optional InventoryItem item = 2;
 * @return {?proto.worklayer.internal.v1.InventoryItem}
 */
proto.worklayer.internal.v1.GetManyInventoryItem.prototype.getItem = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItem} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItem, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItem|undefined} value
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItem} returns this
*/
proto.worklayer.internal.v1.GetManyInventoryItem.prototype.setItem = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.GetManyInventoryItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItem} returns this
 */
proto.worklayer.internal.v1.GetManyInventoryItem.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.GetManyInventoryItem.prototype.hasItem = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional GetInventoryItemError error = 3;
 * @return {?proto.worklayer.internal.v1.GetInventoryItemError}
 */
proto.worklayer.internal.v1.GetManyInventoryItem.prototype.getError = function() {
  return /** @type{?proto.worklayer.internal.v1.GetInventoryItemError} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.GetInventoryItemError, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.GetInventoryItemError|undefined} value
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItem} returns this
*/
proto.worklayer.internal.v1.GetManyInventoryItem.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.worklayer.internal.v1.GetManyInventoryItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItem} returns this
 */
proto.worklayer.internal.v1.GetManyInventoryItem.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.GetManyInventoryItem.prototype.hasError = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetInventoryItemError.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetInventoryItemError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetInventoryItemError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetInventoryItemError.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryItemId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    error: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetInventoryItemError}
 */
proto.worklayer.internal.v1.GetInventoryItemError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetInventoryItemError;
  return proto.worklayer.internal.v1.GetInventoryItemError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetInventoryItemError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetInventoryItemError}
 */
proto.worklayer.internal.v1.GetInventoryItemError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryItemId(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.GetManyInventoryItemsErrorType} */ (reader.readEnum());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetInventoryItemError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetInventoryItemError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetInventoryItemError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetInventoryItemError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryItemId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string inventory_item_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.GetInventoryItemError.prototype.getInventoryItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetInventoryItemError} returns this
 */
proto.worklayer.internal.v1.GetInventoryItemError.prototype.setInventoryItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GetManyInventoryItemsErrorType error = 2;
 * @return {!proto.worklayer.internal.v1.GetManyInventoryItemsErrorType}
 */
proto.worklayer.internal.v1.GetInventoryItemError.prototype.getError = function() {
  return /** @type {!proto.worklayer.internal.v1.GetManyInventoryItemsErrorType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.GetManyInventoryItemsErrorType} value
 * @return {!proto.worklayer.internal.v1.GetInventoryItemError} returns this
 */
proto.worklayer.internal.v1.GetInventoryItemError.prototype.setError = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.repeatedFields_ = [9,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CreateInventoryItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CreateInventoryItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    price: (f = msg.getPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    proPrice: (f = msg.getProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    rootId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    courtesyAmount: jspb.Message.getFieldWithDefault(msg, 7, 0),
    priceType: jspb.Message.getFieldWithDefault(msg, 8, 0),
    supportingItemsList: jspb.Message.toObjectList(msg.getSupportingItemsList(),
    proto.worklayer.internal.v1.InventoryItemSupportingItem.toObject, includeInstance),
    typeSpecification: (f = msg.getTypeSpecification()) && proto.worklayer.internal.v1.InventoryItemTypeSpecification.toObject(includeInstance, f),
    documentSignaturesList: jspb.Message.toObjectList(msg.getDocumentSignaturesList(),
    proto.worklayer.internal.v1.InventoryItemDocumentSignature.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CreateInventoryItemRequest;
  return proto.worklayer.internal.v1.CreateInventoryItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CreateInventoryItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 4:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProPrice(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCourtesyAmount(value);
      break;
    case 8:
      var value = /** @type {!proto.worklayer.internal.v1.InventoryItemPriceType} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    case 9:
      var value = new proto.worklayer.internal.v1.InventoryItemSupportingItem;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemSupportingItem.deserializeBinaryFromReader);
      msg.addSupportingItems(value);
      break;
    case 10:
      var value = new proto.worklayer.internal.v1.InventoryItemTypeSpecification;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemTypeSpecification.deserializeBinaryFromReader);
      msg.setTypeSpecification(value);
      break;
    case 11:
      var value = new proto.worklayer.internal.v1.InventoryItemDocumentSignature;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemDocumentSignature.deserializeBinaryFromReader);
      msg.addDocumentSignatures(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CreateInventoryItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CreateInventoryItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getProPrice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRootId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCourtesyAmount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getSupportingItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.worklayer.internal.v1.InventoryItemSupportingItem.serializeBinaryToWriter
    );
  }
  f = message.getTypeSpecification();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.worklayer.internal.v1.InventoryItemTypeSpecification.serializeBinaryToWriter
    );
  }
  f = message.getDocumentSignaturesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.worklayer.internal.v1.InventoryItemDocumentSignature.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal price = 3;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.getPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 3));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
*/
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal pro_price = 4;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.getProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 4));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
*/
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.setProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.clearProPrice = function() {
  return this.setProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.hasProPrice = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string workspace_id = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string root_id = 6;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.getRootId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.setRootId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 courtesy_amount = 7;
 * @return {number}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.getCourtesyAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.setCourtesyAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional InventoryItemPriceType price_type = 8;
 * @return {!proto.worklayer.internal.v1.InventoryItemPriceType}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.getPriceType = function() {
  return /** @type {!proto.worklayer.internal.v1.InventoryItemPriceType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemPriceType} value
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * repeated InventoryItemSupportingItem supporting_items = 9;
 * @return {!Array<!proto.worklayer.internal.v1.InventoryItemSupportingItem>}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.getSupportingItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.InventoryItemSupportingItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.InventoryItemSupportingItem, 9));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.InventoryItemSupportingItem>} value
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
*/
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.setSupportingItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.addSupportingItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.worklayer.internal.v1.InventoryItemSupportingItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.clearSupportingItemsList = function() {
  return this.setSupportingItemsList([]);
};


/**
 * optional InventoryItemTypeSpecification type_specification = 10;
 * @return {?proto.worklayer.internal.v1.InventoryItemTypeSpecification}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.getTypeSpecification = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemTypeSpecification} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemTypeSpecification, 10));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemTypeSpecification|undefined} value
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
*/
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.setTypeSpecification = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.clearTypeSpecification = function() {
  return this.setTypeSpecification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.hasTypeSpecification = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * repeated InventoryItemDocumentSignature document_signatures = 11;
 * @return {!Array<!proto.worklayer.internal.v1.InventoryItemDocumentSignature>}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.getDocumentSignaturesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.InventoryItemDocumentSignature>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.InventoryItemDocumentSignature, 11));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.InventoryItemDocumentSignature>} value
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
*/
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.setDocumentSignaturesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemDocumentSignature=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.InventoryItemDocumentSignature}
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.addDocumentSignatures = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.worklayer.internal.v1.InventoryItemDocumentSignature, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.CreateInventoryItemRequest.prototype.clearDocumentSignaturesList = function() {
  return this.setDocumentSignaturesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.UpdateInventoryItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.UpdateInventoryItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    options: (f = msg.getOptions()) && proto.worklayer.internal.v1.InventoryItemUpdateOptions.toObject(includeInstance, f),
    updateMask: (f = msg.getUpdateMask()) && google_protobuf_field_mask_pb.FieldMask.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.UpdateInventoryItemRequest}
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.UpdateInventoryItemRequest;
  return proto.worklayer.internal.v1.UpdateInventoryItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.UpdateInventoryItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.UpdateInventoryItemRequest}
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.InventoryItemUpdateOptions;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemUpdateOptions.deserializeBinaryFromReader);
      msg.setOptions(value);
      break;
    case 3:
      var value = new google_protobuf_field_mask_pb.FieldMask;
      reader.readMessage(value,google_protobuf_field_mask_pb.FieldMask.deserializeBinaryFromReader);
      msg.setUpdateMask(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.UpdateInventoryItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.UpdateInventoryItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOptions();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.InventoryItemUpdateOptions.serializeBinaryToWriter
    );
  }
  f = message.getUpdateMask();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_field_mask_pb.FieldMask.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.UpdateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional InventoryItemUpdateOptions options = 2;
 * @return {?proto.worklayer.internal.v1.InventoryItemUpdateOptions}
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.prototype.getOptions = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemUpdateOptions} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemUpdateOptions, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemUpdateOptions|undefined} value
 * @return {!proto.worklayer.internal.v1.UpdateInventoryItemRequest} returns this
*/
proto.worklayer.internal.v1.UpdateInventoryItemRequest.prototype.setOptions = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.UpdateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.prototype.clearOptions = function() {
  return this.setOptions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.prototype.hasOptions = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.FieldMask update_mask = 3;
 * @return {?proto.google.protobuf.FieldMask}
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.prototype.getUpdateMask = function() {
  return /** @type{?proto.google.protobuf.FieldMask} */ (
    jspb.Message.getWrapperField(this, google_protobuf_field_mask_pb.FieldMask, 3));
};


/**
 * @param {?proto.google.protobuf.FieldMask|undefined} value
 * @return {!proto.worklayer.internal.v1.UpdateInventoryItemRequest} returns this
*/
proto.worklayer.internal.v1.UpdateInventoryItemRequest.prototype.setUpdateMask = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.UpdateInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.prototype.clearUpdateMask = function() {
  return this.setUpdateMask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.UpdateInventoryItemRequest.prototype.hasUpdateMask = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CreateInventoryItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CreateInventoryItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CreateInventoryItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateInventoryItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    versionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemResponse}
 */
proto.worklayer.internal.v1.CreateInventoryItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CreateInventoryItemResponse;
  return proto.worklayer.internal.v1.CreateInventoryItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CreateInventoryItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemResponse}
 */
proto.worklayer.internal.v1.CreateInventoryItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CreateInventoryItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CreateInventoryItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CreateInventoryItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CreateInventoryItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateInventoryItemResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemResponse} returns this
 */
proto.worklayer.internal.v1.CreateInventoryItemResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string version_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.CreateInventoryItemResponse.prototype.getVersionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CreateInventoryItemResponse} returns this
 */
proto.worklayer.internal.v1.CreateInventoryItemResponse.prototype.setVersionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.UpdateInventoryItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.UpdateInventoryItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.UpdateInventoryItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UpdateInventoryItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    versionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.UpdateInventoryItemResponse}
 */
proto.worklayer.internal.v1.UpdateInventoryItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.UpdateInventoryItemResponse;
  return proto.worklayer.internal.v1.UpdateInventoryItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.UpdateInventoryItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.UpdateInventoryItemResponse}
 */
proto.worklayer.internal.v1.UpdateInventoryItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.UpdateInventoryItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.UpdateInventoryItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.UpdateInventoryItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UpdateInventoryItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.UpdateInventoryItemResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.UpdateInventoryItemResponse} returns this
 */
proto.worklayer.internal.v1.UpdateInventoryItemResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string version_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.UpdateInventoryItemResponse.prototype.getVersionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.UpdateInventoryItemResponse} returns this
 */
proto.worklayer.internal.v1.UpdateInventoryItemResponse.prototype.setVersionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.repeatedFields_ = [7,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemUpdateOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    price: (f = msg.getPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    proPrice: (f = msg.getProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    courtesyAmount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    supportingItemsList: jspb.Message.toObjectList(msg.getSupportingItemsList(),
    proto.worklayer.internal.v1.InventoryItemSupportingItem.toObject, includeInstance),
    typeSpecification: (f = msg.getTypeSpecification()) && proto.worklayer.internal.v1.InventoryItemTypeSpecification.toObject(includeInstance, f),
    documentSignaturesList: jspb.Message.toObjectList(msg.getDocumentSignaturesList(),
    proto.worklayer.internal.v1.InventoryItemDocumentSignature.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemUpdateOptions;
  return proto.worklayer.internal.v1.InventoryItemUpdateOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 5:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCourtesyAmount(value);
      break;
    case 7:
      var value = new proto.worklayer.internal.v1.InventoryItemSupportingItem;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemSupportingItem.deserializeBinaryFromReader);
      msg.addSupportingItems(value);
      break;
    case 8:
      var value = new proto.worklayer.internal.v1.InventoryItemTypeSpecification;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemTypeSpecification.deserializeBinaryFromReader);
      msg.setTypeSpecification(value);
      break;
    case 9:
      var value = new proto.worklayer.internal.v1.InventoryItemDocumentSignature;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemDocumentSignature.deserializeBinaryFromReader);
      msg.addDocumentSignatures(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemUpdateOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getProPrice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getCourtesyAmount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getSupportingItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.worklayer.internal.v1.InventoryItemSupportingItem.serializeBinaryToWriter
    );
  }
  f = message.getTypeSpecification();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.worklayer.internal.v1.InventoryItemTypeSpecification.serializeBinaryToWriter
    );
  }
  f = message.getDocumentSignaturesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.worklayer.internal.v1.InventoryItemDocumentSignature.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} returns this
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} returns this
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal price = 4;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.getPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 4));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} returns this
*/
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} returns this
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal pro_price = 5;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.getProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 5));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} returns this
*/
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.setProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} returns this
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.clearProPrice = function() {
  return this.setProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.hasProPrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 courtesy_amount = 6;
 * @return {number}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.getCourtesyAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} returns this
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.setCourtesyAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated InventoryItemSupportingItem supporting_items = 7;
 * @return {!Array<!proto.worklayer.internal.v1.InventoryItemSupportingItem>}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.getSupportingItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.InventoryItemSupportingItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.InventoryItemSupportingItem, 7));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.InventoryItemSupportingItem>} value
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} returns this
*/
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.setSupportingItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.addSupportingItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.worklayer.internal.v1.InventoryItemSupportingItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} returns this
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.clearSupportingItemsList = function() {
  return this.setSupportingItemsList([]);
};


/**
 * optional InventoryItemTypeSpecification type_specification = 8;
 * @return {?proto.worklayer.internal.v1.InventoryItemTypeSpecification}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.getTypeSpecification = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemTypeSpecification} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemTypeSpecification, 8));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemTypeSpecification|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} returns this
*/
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.setTypeSpecification = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} returns this
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.clearTypeSpecification = function() {
  return this.setTypeSpecification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.hasTypeSpecification = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated InventoryItemDocumentSignature document_signatures = 9;
 * @return {!Array<!proto.worklayer.internal.v1.InventoryItemDocumentSignature>}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.getDocumentSignaturesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.InventoryItemDocumentSignature>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.InventoryItemDocumentSignature, 9));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.InventoryItemDocumentSignature>} value
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} returns this
*/
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.setDocumentSignaturesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemDocumentSignature=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.InventoryItemDocumentSignature}
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.addDocumentSignatures = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.worklayer.internal.v1.InventoryItemDocumentSignature, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.InventoryItemUpdateOptions} returns this
 */
proto.worklayer.internal.v1.InventoryItemUpdateOptions.prototype.clearDocumentSignaturesList = function() {
  return this.setDocumentSignaturesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListInventoryItemsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListInventoryItemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    workspaceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filter: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orderBy: jspb.Message.getFieldWithDefault(msg, 3, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 5, ""),
    searchText: jspb.Message.getFieldWithDefault(msg, 6, ""),
    workspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsRequest}
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListInventoryItemsRequest;
  return proto.worklayer.internal.v1.ListInventoryItemsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListInventoryItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsRequest}
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilter(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderBy(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchText(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addWorkspaceIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListInventoryItemsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListInventoryItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilter();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderBy();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSearchText();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getWorkspaceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
};


/**
 * optional string workspace_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filter = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.getFilter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.setFilter = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string order_by = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.getOrderBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page_size = 4;
 * @return {number}
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string page_token = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string search_text = 6;
 * @return {string}
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.getSearchText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.setSearchText = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated string workspace_ids = 7;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.getWorkspaceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.setWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.addWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsRequest.prototype.clearWorkspaceIdsList = function() {
  return this.setWorkspaceIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListInventoryItemsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListInventoryItemsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryItemsList: jspb.Message.toObjectList(msg.getInventoryItemsList(),
    proto.worklayer.internal.v1.InventoryItem.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
    totalSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsResponse}
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListInventoryItemsResponse;
  return proto.worklayer.internal.v1.ListInventoryItemsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListInventoryItemsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsResponse}
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.InventoryItem;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItem.deserializeBinaryFromReader);
      msg.addInventoryItems(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListInventoryItemsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListInventoryItemsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.InventoryItem.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated InventoryItem inventory_items = 1;
 * @return {!Array<!proto.worklayer.internal.v1.InventoryItem>}
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.prototype.getInventoryItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.InventoryItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.InventoryItem, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.InventoryItem>} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsResponse} returns this
*/
proto.worklayer.internal.v1.ListInventoryItemsResponse.prototype.setInventoryItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.InventoryItem}
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.prototype.addInventoryItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.InventoryItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsResponse} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.prototype.clearInventoryItemsList = function() {
  return this.setInventoryItemsList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsResponse} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 total_size = 3;
 * @return {number}
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.prototype.getTotalSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsResponse} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsResponse.prototype.setTotalSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    workspaceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filter: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orderBy: jspb.Message.getFieldWithDefault(msg, 3, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 5, ""),
    searchText: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest;
  return proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilter(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderBy(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilter();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderBy();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSearchText();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string workspace_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filter = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.getFilter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.setFilter = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string order_by = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.getOrderBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page_size = 4;
 * @return {number}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string page_token = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string search_text = 6;
 * @return {string}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.getSearchText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersRequest.prototype.setSearchText = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryItemsList: jspb.Message.toObjectList(msg.getInventoryItemsList(),
    proto.worklayer.internal.v1.InventoryItemForProviders.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse;
  return proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.InventoryItemForProviders;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemForProviders.deserializeBinaryFromReader);
      msg.addInventoryItems(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.InventoryItemForProviders.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated InventoryItemForProviders inventory_items = 1;
 * @return {!Array<!proto.worklayer.internal.v1.InventoryItemForProviders>}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.prototype.getInventoryItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.InventoryItemForProviders>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.InventoryItemForProviders, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.InventoryItemForProviders>} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse} returns this
*/
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.prototype.setInventoryItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemForProviders=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.InventoryItemForProviders}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.prototype.addInventoryItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.InventoryItemForProviders, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.prototype.clearInventoryItemsList = function() {
  return this.setInventoryItemsList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse} returns this
 */
proto.worklayer.internal.v1.ListInventoryItemsForProvidersResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.InventoryItem.repeatedFields_ = [17,24];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rootId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    archived: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    proVisibility: jspb.Message.getFieldWithDefault(msg, 5, 0),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    description: jspb.Message.getFieldWithDefault(msg, 7, ""),
    version: jspb.Message.getFieldWithDefault(msg, 8, 0),
    courtesyAmount: jspb.Message.getFieldWithDefault(msg, 9, 0),
    price: (f = msg.getPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    proPrice: (f = msg.getProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    createdBy: jspb.Message.getFieldWithDefault(msg, 12, ""),
    dateCreated: (f = msg.getDateCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    shortId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    priceType: jspb.Message.getFieldWithDefault(msg, 15, 0),
    versionId: jspb.Message.getFieldWithDefault(msg, 16, ""),
    supportingItemsList: jspb.Message.toObjectList(msg.getSupportingItemsList(),
    proto.worklayer.internal.v1.InventoryItemSupportingItem.toObject, includeInstance),
    archivedBy: (f = msg.getArchivedBy()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    dateArchived: (f = msg.getDateArchived()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    importedFromId: (f = msg.getImportedFromId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    updatedBy: (f = msg.getUpdatedBy()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    dateUpdated: (f = msg.getDateUpdated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    typeSpecification: (f = msg.getTypeSpecification()) && proto.worklayer.internal.v1.InventoryItemTypeSpecification.toObject(includeInstance, f),
    documentSignaturesList: jspb.Message.toObjectList(msg.getDocumentSignaturesList(),
    proto.worklayer.internal.v1.InventoryItemDocumentSignature.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItem}
 */
proto.worklayer.internal.v1.InventoryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItem;
  return proto.worklayer.internal.v1.InventoryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItem}
 */
proto.worklayer.internal.v1.InventoryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArchived(value);
      break;
    case 5:
      var value = /** @type {!proto.worklayer.internal.v1.InventoryItemProVisibility} */ (reader.readEnum());
      msg.setProVisibility(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCourtesyAmount(value);
      break;
    case 10:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 11:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProPrice(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateCreated(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortId(value);
      break;
    case 15:
      var value = /** @type {!proto.worklayer.internal.v1.InventoryItemPriceType} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionId(value);
      break;
    case 17:
      var value = new proto.worklayer.internal.v1.InventoryItemSupportingItem;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemSupportingItem.deserializeBinaryFromReader);
      msg.addSupportingItems(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setArchivedBy(value);
      break;
    case 19:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateArchived(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setImportedFromId(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setUpdatedBy(value);
      break;
    case 22:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateUpdated(value);
      break;
    case 23:
      var value = new proto.worklayer.internal.v1.InventoryItemTypeSpecification;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemTypeSpecification.deserializeBinaryFromReader);
      msg.setTypeSpecification(value);
      break;
    case 24:
      var value = new proto.worklayer.internal.v1.InventoryItemDocumentSignature;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemDocumentSignature.deserializeBinaryFromReader);
      msg.addDocumentSignatures(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRootId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getArchived();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getProVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCourtesyAmount();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getProPrice();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getDateCreated();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getShortId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getVersionId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getSupportingItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      proto.worklayer.internal.v1.InventoryItemSupportingItem.serializeBinaryToWriter
    );
  }
  f = message.getArchivedBy();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDateArchived();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getImportedFromId();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedBy();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDateUpdated();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTypeSpecification();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.worklayer.internal.v1.InventoryItemTypeSpecification.serializeBinaryToWriter
    );
  }
  f = message.getDocumentSignaturesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      24,
      f,
      proto.worklayer.internal.v1.InventoryItemDocumentSignature.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string root_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getRootId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.setRootId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string workspace_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool archived = 4;
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.setArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional InventoryItemProVisibility pro_visibility = 5;
 * @return {!proto.worklayer.internal.v1.InventoryItemProVisibility}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getProVisibility = function() {
  return /** @type {!proto.worklayer.internal.v1.InventoryItemProVisibility} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemProVisibility} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.setProVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 version = 8;
 * @return {number}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 courtesy_amount = 9;
 * @return {number}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getCourtesyAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.setCourtesyAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal price = 10;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 10));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
*/
proto.worklayer.internal.v1.InventoryItem.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal pro_price = 11;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 11));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
*/
proto.worklayer.internal.v1.InventoryItem.prototype.setProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.clearProPrice = function() {
  return this.setProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.hasProPrice = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string created_by = 12;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional google.protobuf.Timestamp date_created = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getDateCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
*/
proto.worklayer.internal.v1.InventoryItem.prototype.setDateCreated = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.clearDateCreated = function() {
  return this.setDateCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.hasDateCreated = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string short_id = 14;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getShortId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.setShortId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional InventoryItemPriceType price_type = 15;
 * @return {!proto.worklayer.internal.v1.InventoryItemPriceType}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getPriceType = function() {
  return /** @type {!proto.worklayer.internal.v1.InventoryItemPriceType} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemPriceType} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional string version_id = 16;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getVersionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.setVersionId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * repeated InventoryItemSupportingItem supporting_items = 17;
 * @return {!Array<!proto.worklayer.internal.v1.InventoryItemSupportingItem>}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getSupportingItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.InventoryItemSupportingItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.InventoryItemSupportingItem, 17));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.InventoryItemSupportingItem>} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
*/
proto.worklayer.internal.v1.InventoryItem.prototype.setSupportingItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.addSupportingItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.worklayer.internal.v1.InventoryItemSupportingItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.clearSupportingItemsList = function() {
  return this.setSupportingItemsList([]);
};


/**
 * optional google.protobuf.StringValue archived_by = 18;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getArchivedBy = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 18));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
*/
proto.worklayer.internal.v1.InventoryItem.prototype.setArchivedBy = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.clearArchivedBy = function() {
  return this.setArchivedBy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.hasArchivedBy = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.Timestamp date_archived = 19;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getDateArchived = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 19));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
*/
proto.worklayer.internal.v1.InventoryItem.prototype.setDateArchived = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.clearDateArchived = function() {
  return this.setDateArchived(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.hasDateArchived = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.StringValue imported_from_id = 20;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getImportedFromId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 20));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
*/
proto.worklayer.internal.v1.InventoryItem.prototype.setImportedFromId = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.clearImportedFromId = function() {
  return this.setImportedFromId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.hasImportedFromId = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.StringValue updated_by = 21;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getUpdatedBy = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 21));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
*/
proto.worklayer.internal.v1.InventoryItem.prototype.setUpdatedBy = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.clearUpdatedBy = function() {
  return this.setUpdatedBy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.hasUpdatedBy = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.Timestamp date_updated = 22;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getDateUpdated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 22));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
*/
proto.worklayer.internal.v1.InventoryItem.prototype.setDateUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.clearDateUpdated = function() {
  return this.setDateUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.hasDateUpdated = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional InventoryItemTypeSpecification type_specification = 23;
 * @return {?proto.worklayer.internal.v1.InventoryItemTypeSpecification}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getTypeSpecification = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemTypeSpecification} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemTypeSpecification, 23));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemTypeSpecification|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
*/
proto.worklayer.internal.v1.InventoryItem.prototype.setTypeSpecification = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.clearTypeSpecification = function() {
  return this.setTypeSpecification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.hasTypeSpecification = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * repeated InventoryItemDocumentSignature document_signatures = 24;
 * @return {!Array<!proto.worklayer.internal.v1.InventoryItemDocumentSignature>}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.getDocumentSignaturesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.InventoryItemDocumentSignature>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.InventoryItemDocumentSignature, 24));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.InventoryItemDocumentSignature>} value
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
*/
proto.worklayer.internal.v1.InventoryItem.prototype.setDocumentSignaturesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 24, value);
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemDocumentSignature=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.InventoryItemDocumentSignature}
 */
proto.worklayer.internal.v1.InventoryItem.prototype.addDocumentSignatures = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 24, opt_value, proto.worklayer.internal.v1.InventoryItemDocumentSignature, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.InventoryItem} returns this
 */
proto.worklayer.internal.v1.InventoryItem.prototype.clearDocumentSignaturesList = function() {
  return this.setDocumentSignaturesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    required: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    spec: (f = msg.getSpec()) && proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemSupportingItem;
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequired(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.deserializeBinaryFromReader);
      msg.setSpec(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemSupportingItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequired();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getSpec();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.oneofGroups_ = [[1,2,3,4,5,6,7,8]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.TypeCase = {
  TYPE_NOT_SET: 0,
  DOCUMENT: 1,
  PERSONAL_INFO: 2,
  SPOUSAL_INFO: 3,
  DEPENDENTS_INFO: 4,
  PERSONAL_REFUND_METHOD: 5,
  BUSINESS_INFO: 6,
  BUSINESS_REFUND_METHOD: 7,
  NOTES: 8
};

/**
 * @return {proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.TypeCase}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.toObject = function(includeInstance, msg) {
  var f, obj = {
    document: (f = msg.getDocument()) && proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.toObject(includeInstance, f),
    personalInfo: (f = msg.getPersonalInfo()) && proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo.toObject(includeInstance, f),
    spousalInfo: (f = msg.getSpousalInfo()) && proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo.toObject(includeInstance, f),
    dependentsInfo: (f = msg.getDependentsInfo()) && proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo.toObject(includeInstance, f),
    personalRefundMethod: (f = msg.getPersonalRefundMethod()) && proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod.toObject(includeInstance, f),
    businessInfo: (f = msg.getBusinessInfo()) && proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo.toObject(includeInstance, f),
    businessRefundMethod: (f = msg.getBusinessRefundMethod()) && proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod.toObject(includeInstance, f),
    notes: (f = msg.getNotes()) && proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec;
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.deserializeBinaryFromReader);
      msg.setDocument(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo.deserializeBinaryFromReader);
      msg.setPersonalInfo(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo.deserializeBinaryFromReader);
      msg.setSpousalInfo(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo.deserializeBinaryFromReader);
      msg.setDependentsInfo(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod.deserializeBinaryFromReader);
      msg.setPersonalRefundMethod(value);
      break;
    case 6:
      var value = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo.deserializeBinaryFromReader);
      msg.setBusinessInfo(value);
      break;
    case 7:
      var value = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod.deserializeBinaryFromReader);
      msg.setBusinessRefundMethod(value);
      break;
    case 8:
      var value = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes.deserializeBinaryFromReader);
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocument();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.serializeBinaryToWriter
    );
  }
  f = message.getPersonalInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo.serializeBinaryToWriter
    );
  }
  f = message.getSpousalInfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo.serializeBinaryToWriter
    );
  }
  f = message.getDependentsInfo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo.serializeBinaryToWriter
    );
  }
  f = message.getPersonalRefundMethod();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod.serializeBinaryToWriter
    );
  }
  f = message.getBusinessInfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo.serializeBinaryToWriter
    );
  }
  f = message.getBusinessRefundMethod();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod.serializeBinaryToWriter
    );
  }
  f = message.getNotes();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.toObject = function(includeInstance, msg) {
  var f, obj = {
    typeShortId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document;
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeShortId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTypeShortId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string type_short_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.prototype.getTypeShortId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document} returns this
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document.prototype.setTypeShortId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo;
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo;
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo;
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod;
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo;
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod;
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes;
  return proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional Document document = 1;
 * @return {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.getDocument = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Document|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
*/
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.setDocument = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.clearDocument = function() {
  return this.setDocument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.hasDocument = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PersonalInfo personal_info = 2;
 * @return {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.getPersonalInfo = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalInfo|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
*/
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.setPersonalInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.clearPersonalInfo = function() {
  return this.setPersonalInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.hasPersonalInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SpousalInfo spousal_info = 3;
 * @return {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.getSpousalInfo = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.SpousalInfo|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
*/
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.setSpousalInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.clearSpousalInfo = function() {
  return this.setSpousalInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.hasSpousalInfo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional DependentsInfo dependents_info = 4;
 * @return {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.getDependentsInfo = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo, 4));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.DependentsInfo|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
*/
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.setDependentsInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.clearDependentsInfo = function() {
  return this.setDependentsInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.hasDependentsInfo = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional PersonalRefundMethod personal_refund_method = 5;
 * @return {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.getPersonalRefundMethod = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.PersonalRefundMethod|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
*/
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.setPersonalRefundMethod = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.clearPersonalRefundMethod = function() {
  return this.setPersonalRefundMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.hasPersonalRefundMethod = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional BusinessInfo business_info = 6;
 * @return {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.getBusinessInfo = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo, 6));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessInfo|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
*/
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.setBusinessInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.clearBusinessInfo = function() {
  return this.setBusinessInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.hasBusinessInfo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional BusinessRefundMethod business_refund_method = 7;
 * @return {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.getBusinessRefundMethod = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod, 7));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.BusinessRefundMethod|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
*/
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.setBusinessRefundMethod = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.clearBusinessRefundMethod = function() {
  return this.setBusinessRefundMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.hasBusinessRefundMethod = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Notes notes = 8;
 * @return {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.getNotes = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes, 8));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.Notes|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
*/
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.setNotes = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} returns this
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.clearNotes = function() {
  return this.setNotes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec.prototype.hasNotes = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool required = 1;
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.prototype.getRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem} returns this
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.prototype.setRequired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Spec spec = 2;
 * @return {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.prototype.getSpec = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemSupportingItem.Spec|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem} returns this
*/
proto.worklayer.internal.v1.InventoryItemSupportingItem.prototype.setSpec = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemSupportingItem} returns this
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.prototype.clearSpec = function() {
  return this.setSpec(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemSupportingItem.prototype.hasSpec = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemDocumentSignature.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemDocumentSignature.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemDocumentSignature} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemDocumentSignature.toObject = function(includeInstance, msg) {
  var f, obj = {
    documentTypeShortId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemDocumentSignature}
 */
proto.worklayer.internal.v1.InventoryItemDocumentSignature.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemDocumentSignature;
  return proto.worklayer.internal.v1.InventoryItemDocumentSignature.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemDocumentSignature} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemDocumentSignature}
 */
proto.worklayer.internal.v1.InventoryItemDocumentSignature.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentTypeShortId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemDocumentSignature.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemDocumentSignature.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemDocumentSignature} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemDocumentSignature.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentTypeShortId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string document_type_short_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItemDocumentSignature.prototype.getDocumentTypeShortId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItemDocumentSignature} returns this
 */
proto.worklayer.internal.v1.InventoryItemDocumentSignature.prototype.setDocumentTypeShortId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.toObject = function(includeInstance, msg) {
  var f, obj = {
    spec: (f = msg.getSpec()) && proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemTypeSpecification;
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.deserializeBinaryFromReader);
      msg.setSpec(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSpec();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TypeCase = {
  TYPE_NOT_SET: 0,
  DEFAULT: 1,
  BOOKKEEPING: 2,
  CONSULTATION: 3,
  TAX: 4,
  TAX_EXTENSION: 5
};

/**
 * @return {proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TypeCase}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.toObject = function(includeInstance, msg) {
  var f, obj = {
    pb_default: (f = msg.getDefault()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f),
    bookkeeping: (f = msg.getBookkeeping()) && proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.toObject(includeInstance, f),
    consultation: (f = msg.getConsultation()) && proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.toObject(includeInstance, f),
    tax: (f = msg.getTax()) && proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.toObject(includeInstance, f),
    taxExtension: (f = msg.getTaxExtension()) && proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions;
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setDefault(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.deserializeBinaryFromReader);
      msg.setBookkeeping(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.deserializeBinaryFromReader);
      msg.setConsultation(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.deserializeBinaryFromReader);
      msg.setTax(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.deserializeBinaryFromReader);
      msg.setTaxExtension(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDefault();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
  f = message.getBookkeeping();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.serializeBinaryToWriter
    );
  }
  f = message.getConsultation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.serializeBinaryToWriter
    );
  }
  f = message.getTax();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.serializeBinaryToWriter
    );
  }
  f = message.getTaxExtension();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.toObject = function(includeInstance, msg) {
  var f, obj = {
    recurring: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping;
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRecurring(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecurring();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool recurring = 1;
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.prototype.getRecurring = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping.prototype.setRecurring = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.toObject = function(includeInstance, msg) {
  var f, obj = {
    lengthInMinutes: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation;
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLengthInMinutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLengthInMinutes();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 length_in_minutes = 1;
 * @return {number}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.prototype.getLengthInMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation.prototype.setLengthInMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.toObject = function(includeInstance, msg) {
  var f, obj = {
    reviewPrice: (f = msg.getReviewPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    reviewProPrice: (f = msg.getReviewProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax;
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setReviewPrice(value);
      break;
    case 2:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setReviewProPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReviewPrice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getReviewProPrice();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional worklayer.shared.types.v1.Decimal review_price = 1;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.prototype.getReviewPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 1));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.prototype.setReviewPrice = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.prototype.clearReviewPrice = function() {
  return this.setReviewPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.prototype.hasReviewPrice = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal review_pro_price = 2;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.prototype.getReviewProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 2));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.prototype.setReviewProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.prototype.clearReviewProPrice = function() {
  return this.setReviewProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax.prototype.hasReviewProPrice = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    billingType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    billingInfo: (f = msg.getBillingInfo()) && proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension;
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.ExtensionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.ExtensionBillingType} */ (reader.readEnum());
      msg.setBillingType(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.deserializeBinaryFromReader);
      msg.setBillingInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBillingType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getBillingInfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.ExtensionType = {
  PERSONAL: 0,
  BUSINESS: 1,
  OUTSOURCING: 2
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.ExtensionBillingType = {
  EXTENSION_BILLING_TYPE_UNSPECIFIED: 0,
  PERCENTAGE: 1,
  FLAT_FEE: 2
};

/**
 * optional ExtensionType type = 1;
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.ExtensionType}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.prototype.getType = function() {
  return /** @type {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.ExtensionType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.ExtensionType} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ExtensionBillingType billing_type = 2;
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.ExtensionBillingType}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.prototype.getBillingType = function() {
  return /** @type {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.ExtensionBillingType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.ExtensionBillingType} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.prototype.setBillingType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional TaxExtensionBillingInfo billing_info = 3;
 * @return {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.prototype.getBillingInfo = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.prototype.setBillingInfo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.prototype.clearBillingInfo = function() {
  return this.setBillingInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension.prototype.hasBillingInfo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Empty default = 1;
 * @return {?proto.google.protobuf.Empty}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.getDefault = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 1));
};


/**
 * @param {?proto.google.protobuf.Empty|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.setDefault = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.clearDefault = function() {
  return this.setDefault(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.hasDefault = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Bookkeeping bookkeeping = 2;
 * @return {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.getBookkeeping = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Bookkeeping|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.setBookkeeping = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.clearBookkeeping = function() {
  return this.setBookkeeping(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.hasBookkeeping = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Consultation consultation = 3;
 * @return {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.getConsultation = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Consultation|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.setConsultation = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.clearConsultation = function() {
  return this.setConsultation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.hasConsultation = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Tax tax = 4;
 * @return {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.getTax = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax, 4));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.Tax|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.setTax = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.clearTax = function() {
  return this.setTax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.hasTax = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional TaxExtension tax_extension = 5;
 * @return {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.getTaxExtension = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.TaxExtension|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.setTaxExtension = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.clearTaxExtension = function() {
  return this.setTaxExtension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions.prototype.hasTaxExtension = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.TypeCase = {
  TYPE_NOT_SET: 0,
  UNSPECIFIED: 1,
  REGULAR: 2,
  JOB_PROGRESSION: 3
};

/**
 * @return {proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.TypeCase}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    unspecified: (f = msg.getUnspecified()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f),
    regular: (f = msg.getRegular()) && proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.toObject(includeInstance, f),
    jobProgression: (f = msg.getJobProgression()) && proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo;
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setUnspecified(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.deserializeBinaryFromReader);
      msg.setRegular(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.deserializeBinaryFromReader);
      msg.setJobProgression(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnspecified();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
  f = message.getRegular();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.serializeBinaryToWriter
    );
  }
  f = message.getJobProgression();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientChargeAmount: (f = msg.getClientChargeAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    proPayoutAmount: (f = msg.getProPayoutAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo;
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setClientChargeAmount(value);
      break;
    case 2:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProPayoutAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientChargeAmount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getProPayoutAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional worklayer.shared.types.v1.Decimal client_charge_amount = 1;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.prototype.getClientChargeAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 1));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.prototype.setClientChargeAmount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.prototype.clearClientChargeAmount = function() {
  return this.setClientChargeAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.prototype.hasClientChargeAmount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal pro_payout_amount = 2;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.prototype.getProPayoutAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 2));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.prototype.setProPayoutAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.prototype.clearProPayoutAmount = function() {
  return this.setProPayoutAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo.prototype.hasProPayoutAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingInfo: (f = msg.getBillingInfo()) && proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo;
  return proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.deserializeBinaryFromReader);
      msg.setBillingInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional InventoryItemJobProgressionBillingInfo billing_info = 1;
 * @return {?proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.prototype.getBillingInfo = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.prototype.setBillingInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.prototype.clearBillingInfo = function() {
  return this.setBillingInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo.prototype.hasBillingInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Empty unspecified = 1;
 * @return {?proto.google.protobuf.Empty}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.getUnspecified = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 1));
};


/**
 * @param {?proto.google.protobuf.Empty|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.setUnspecified = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.clearUnspecified = function() {
  return this.setUnspecified(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.hasUnspecified = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RegularBillingInfo regular = 2;
 * @return {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.getRegular = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.RegularBillingInfo|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.setRegular = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.clearRegular = function() {
  return this.setRegular(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.hasRegular = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional JobProgressionBillingInfo job_progression = 3;
 * @return {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.getJobProgression = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.JobProgressionBillingInfo|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.setJobProgression = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.clearJobProgression = function() {
  return this.setJobProgression(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.TaxExtensionBillingInfo.prototype.hasJobProgression = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TypeOptions spec = 1;
 * @return {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.prototype.getSpec = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemTypeSpecification.TypeOptions|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification} returns this
*/
proto.worklayer.internal.v1.InventoryItemTypeSpecification.prototype.setSpec = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemTypeSpecification} returns this
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.prototype.clearSpec = function() {
  return this.setSpec(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemTypeSpecification.prototype.hasSpec = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemForProviders.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemForProviders} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemForProviders.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rootId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, ""),
    shortId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    versionId: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemForProviders}
 */
proto.worklayer.internal.v1.InventoryItemForProviders.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemForProviders;
  return proto.worklayer.internal.v1.InventoryItemForProviders.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemForProviders} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemForProviders}
 */
proto.worklayer.internal.v1.InventoryItemForProviders.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemForProviders.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemForProviders} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemForProviders.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRootId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getShortId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getVersionId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItemForProviders} returns this
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string root_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.getRootId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItemForProviders} returns this
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.setRootId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string workspace_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItemForProviders} returns this
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItemForProviders} returns this
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItemForProviders} returns this
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string short_id = 6;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.getShortId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItemForProviders} returns this
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.setShortId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string version_id = 7;
 * @return {string}
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.getVersionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.InventoryItemForProviders} returns this
 */
proto.worklayer.internal.v1.InventoryItemForProviders.prototype.setVersionId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ArchiveInventoryItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ArchiveInventoryItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ArchiveInventoryItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ArchiveInventoryItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ArchiveInventoryItemRequest}
 */
proto.worklayer.internal.v1.ArchiveInventoryItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ArchiveInventoryItemRequest;
  return proto.worklayer.internal.v1.ArchiveInventoryItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ArchiveInventoryItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ArchiveInventoryItemRequest}
 */
proto.worklayer.internal.v1.ArchiveInventoryItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ArchiveInventoryItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ArchiveInventoryItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ArchiveInventoryItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ArchiveInventoryItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ArchiveInventoryItemRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ArchiveInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.ArchiveInventoryItemRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ArchiveInventoryItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ArchiveInventoryItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ArchiveInventoryItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ArchiveInventoryItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    archived: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ArchiveInventoryItemResponse}
 */
proto.worklayer.internal.v1.ArchiveInventoryItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ArchiveInventoryItemResponse;
  return proto.worklayer.internal.v1.ArchiveInventoryItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ArchiveInventoryItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ArchiveInventoryItemResponse}
 */
proto.worklayer.internal.v1.ArchiveInventoryItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArchived(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ArchiveInventoryItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ArchiveInventoryItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ArchiveInventoryItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ArchiveInventoryItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getArchived();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ArchiveInventoryItemResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ArchiveInventoryItemResponse} returns this
 */
proto.worklayer.internal.v1.ArchiveInventoryItemResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool archived = 2;
 * @return {boolean}
 */
proto.worklayer.internal.v1.ArchiveInventoryItemResponse.prototype.getArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.ArchiveInventoryItemResponse} returns this
 */
proto.worklayer.internal.v1.ArchiveInventoryItemResponse.prototype.setArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.UnarchiveInventoryItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.UnarchiveInventoryItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.UnarchiveInventoryItemRequest}
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.UnarchiveInventoryItemRequest;
  return proto.worklayer.internal.v1.UnarchiveInventoryItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.UnarchiveInventoryItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.UnarchiveInventoryItemRequest}
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.UnarchiveInventoryItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.UnarchiveInventoryItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.UnarchiveInventoryItemRequest} returns this
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.UnarchiveInventoryItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    archived: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.UnarchiveInventoryItemResponse}
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.UnarchiveInventoryItemResponse;
  return proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.UnarchiveInventoryItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.UnarchiveInventoryItemResponse}
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArchived(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.UnarchiveInventoryItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getArchived();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.UnarchiveInventoryItemResponse} returns this
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool archived = 2;
 * @return {boolean}
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.prototype.getArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.UnarchiveInventoryItemResponse} returns this
 */
proto.worklayer.internal.v1.UnarchiveInventoryItemResponse.prototype.setArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetProVisibilityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetProVisibilityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetProVisibilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetProVisibilityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    visibility: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetProVisibilityRequest}
 */
proto.worklayer.internal.v1.SetProVisibilityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetProVisibilityRequest;
  return proto.worklayer.internal.v1.SetProVisibilityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetProVisibilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetProVisibilityRequest}
 */
proto.worklayer.internal.v1.SetProVisibilityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.InventoryItemProVisibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetProVisibilityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetProVisibilityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetProVisibilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetProVisibilityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetProVisibilityRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetProVisibilityRequest} returns this
 */
proto.worklayer.internal.v1.SetProVisibilityRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional InventoryItemProVisibility visibility = 2;
 * @return {!proto.worklayer.internal.v1.InventoryItemProVisibility}
 */
proto.worklayer.internal.v1.SetProVisibilityRequest.prototype.getVisibility = function() {
  return /** @type {!proto.worklayer.internal.v1.InventoryItemProVisibility} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemProVisibility} value
 * @return {!proto.worklayer.internal.v1.SetProVisibilityRequest} returns this
 */
proto.worklayer.internal.v1.SetProVisibilityRequest.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetProVisibilityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetProVisibilityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetProVisibilityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetProVisibilityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    visibility: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetProVisibilityResponse}
 */
proto.worklayer.internal.v1.SetProVisibilityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetProVisibilityResponse;
  return proto.worklayer.internal.v1.SetProVisibilityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetProVisibilityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetProVisibilityResponse}
 */
proto.worklayer.internal.v1.SetProVisibilityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.InventoryItemProVisibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetProVisibilityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetProVisibilityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetProVisibilityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetProVisibilityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetProVisibilityResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetProVisibilityResponse} returns this
 */
proto.worklayer.internal.v1.SetProVisibilityResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional InventoryItemProVisibility visibility = 2;
 * @return {!proto.worklayer.internal.v1.InventoryItemProVisibility}
 */
proto.worklayer.internal.v1.SetProVisibilityResponse.prototype.getVisibility = function() {
  return /** @type {!proto.worklayer.internal.v1.InventoryItemProVisibility} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.InventoryItemProVisibility} value
 * @return {!proto.worklayer.internal.v1.SetProVisibilityResponse} returns this
 */
proto.worklayer.internal.v1.SetProVisibilityResponse.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.WorkspaceWithInventoryItems.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.WorkspaceWithInventoryItems.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.WorkspaceWithInventoryItems} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.WorkspaceWithInventoryItems.toObject = function(includeInstance, msg) {
  var f, obj = {
    workspaceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.WorkspaceWithInventoryItems}
 */
proto.worklayer.internal.v1.WorkspaceWithInventoryItems.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.WorkspaceWithInventoryItems;
  return proto.worklayer.internal.v1.WorkspaceWithInventoryItems.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.WorkspaceWithInventoryItems} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.WorkspaceWithInventoryItems}
 */
proto.worklayer.internal.v1.WorkspaceWithInventoryItems.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.WorkspaceWithInventoryItems.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.WorkspaceWithInventoryItems.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.WorkspaceWithInventoryItems} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.WorkspaceWithInventoryItems.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string workspace_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.WorkspaceWithInventoryItems.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.WorkspaceWithInventoryItems} returns this
 */
proto.worklayer.internal.v1.WorkspaceWithInventoryItems.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.worklayer.internal.v1.WorkspaceWithInventoryItems.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.WorkspaceWithInventoryItems} returns this
 */
proto.worklayer.internal.v1.WorkspaceWithInventoryItems.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest}
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest;
  return proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest}
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    workspacesList: jspb.Message.toObjectList(msg.getWorkspacesList(),
    proto.worklayer.internal.v1.WorkspaceWithInventoryItems.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse}
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse;
  return proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse}
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.WorkspaceWithInventoryItems;
      reader.readMessage(value,proto.worklayer.internal.v1.WorkspaceWithInventoryItems.deserializeBinaryFromReader);
      msg.addWorkspaces(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspacesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.WorkspaceWithInventoryItems.serializeBinaryToWriter
    );
  }
};


/**
 * repeated WorkspaceWithInventoryItems workspaces = 1;
 * @return {!Array<!proto.worklayer.internal.v1.WorkspaceWithInventoryItems>}
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.prototype.getWorkspacesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.WorkspaceWithInventoryItems>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.WorkspaceWithInventoryItems, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.WorkspaceWithInventoryItems>} value
 * @return {!proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse} returns this
*/
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.prototype.setWorkspacesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.WorkspaceWithInventoryItems=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.WorkspaceWithInventoryItems}
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.prototype.addWorkspaces = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.WorkspaceWithInventoryItems, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse} returns this
 */
proto.worklayer.internal.v1.ListWorkspacesWithInventoryItemsResponse.prototype.clearWorkspacesList = function() {
  return this.setWorkspacesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    outsourcing: (f = msg.getOutsourcing()) && proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.toObject(includeInstance, f),
    retail: (f = msg.getRetail()) && proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.toObject(includeInstance, f),
    essential: (f = msg.getEssential()) && proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.toObject(includeInstance, f),
    preparation: (f = msg.getPreparation()) && proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.toObject(includeInstance, f),
    review: (f = msg.getReview()) && proto.worklayer.internal.v1.InventoryItemJobProgressionReview.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo;
  return proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.deserializeBinaryFromReader);
      msg.setOutsourcing(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.InventoryItemJobProgressionRetail;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.deserializeBinaryFromReader);
      msg.setRetail(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.InventoryItemJobProgressionEssential;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.deserializeBinaryFromReader);
      msg.setEssential(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.deserializeBinaryFromReader);
      msg.setPreparation(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.InventoryItemJobProgressionReview;
      reader.readMessage(value,proto.worklayer.internal.v1.InventoryItemJobProgressionReview.deserializeBinaryFromReader);
      msg.setReview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOutsourcing();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.serializeBinaryToWriter
    );
  }
  f = message.getRetail();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.serializeBinaryToWriter
    );
  }
  f = message.getEssential();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.serializeBinaryToWriter
    );
  }
  f = message.getPreparation();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.serializeBinaryToWriter
    );
  }
  f = message.getReview();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.v1.InventoryItemJobProgressionReview.serializeBinaryToWriter
    );
  }
};


/**
 * optional InventoryItemJobProgressionOutsourcing outsourcing = 1;
 * @return {?proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.getOutsourcing = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.setOutsourcing = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.clearOutsourcing = function() {
  return this.setOutsourcing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.hasOutsourcing = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional InventoryItemJobProgressionRetail retail = 2;
 * @return {?proto.worklayer.internal.v1.InventoryItemJobProgressionRetail}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.getRetail = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemJobProgressionRetail, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemJobProgressionRetail|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.setRetail = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.clearRetail = function() {
  return this.setRetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.hasRetail = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional InventoryItemJobProgressionEssential essential = 3;
 * @return {?proto.worklayer.internal.v1.InventoryItemJobProgressionEssential}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.getEssential = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemJobProgressionEssential} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemJobProgressionEssential, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemJobProgressionEssential|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.setEssential = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.clearEssential = function() {
  return this.setEssential(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.hasEssential = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional InventoryItemJobProgressionPreparation preparation = 4;
 * @return {?proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.getPreparation = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation, 4));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.setPreparation = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.clearPreparation = function() {
  return this.setPreparation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.hasPreparation = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional InventoryItemJobProgressionReview review = 5;
 * @return {?proto.worklayer.internal.v1.InventoryItemJobProgressionReview}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.getReview = function() {
  return /** @type{?proto.worklayer.internal.v1.InventoryItemJobProgressionReview} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InventoryItemJobProgressionReview, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.InventoryItemJobProgressionReview|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.setReview = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.clearReview = function() {
  return this.setReview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionBillingInfo.prototype.hasReview = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobStarted: (f = msg.getJobStarted()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    openItems: (f = msg.getOpenItems()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    draftInReview: (f = msg.getDraftInReview()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    draftRejected: (f = msg.getDraftRejected()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    draftApproved: (f = msg.getDraftApproved()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing;
  return proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setJobStarted(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setOpenItems(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setDraftInReview(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setDraftRejected(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setDraftApproved(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobStarted();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getOpenItems();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getDraftInReview();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getDraftRejected();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getDraftApproved();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProgressionStepBillingValues job_started = 1;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.getJobStarted = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.setJobStarted = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.clearJobStarted = function() {
  return this.setJobStarted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.hasJobStarted = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ProgressionStepBillingValues open_items = 2;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.getOpenItems = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.setOpenItems = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.clearOpenItems = function() {
  return this.setOpenItems(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.hasOpenItems = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ProgressionStepBillingValues draft_in_review = 3;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.getDraftInReview = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.setDraftInReview = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.clearDraftInReview = function() {
  return this.setDraftInReview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.hasDraftInReview = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ProgressionStepBillingValues draft_rejected = 4;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.getDraftRejected = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 4));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.setDraftRejected = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.clearDraftRejected = function() {
  return this.setDraftRejected(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.hasDraftRejected = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ProgressionStepBillingValues draft_approved = 5;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.getDraftApproved = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.setDraftApproved = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.clearDraftApproved = function() {
  return this.setDraftApproved(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionOutsourcing.prototype.hasDraftApproved = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobStarted: (f = msg.getJobStarted()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    openItems: (f = msg.getOpenItems()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    draftInReview: (f = msg.getDraftInReview()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    draftRejected: (f = msg.getDraftRejected()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    draftApproved: (f = msg.getDraftApproved()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    authorizationSigned: (f = msg.getAuthorizationSigned()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    returnFiled: (f = msg.getReturnFiled()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemJobProgressionRetail;
  return proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setJobStarted(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setOpenItems(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setDraftInReview(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setDraftRejected(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setDraftApproved(value);
      break;
    case 6:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setAuthorizationSigned(value);
      break;
    case 7:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setReturnFiled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobStarted();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getOpenItems();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getDraftInReview();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getDraftRejected();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getDraftApproved();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getAuthorizationSigned();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getReturnFiled();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProgressionStepBillingValues job_started = 1;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.getJobStarted = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.setJobStarted = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.clearJobStarted = function() {
  return this.setJobStarted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.hasJobStarted = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ProgressionStepBillingValues open_items = 2;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.getOpenItems = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.setOpenItems = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.clearOpenItems = function() {
  return this.setOpenItems(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.hasOpenItems = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ProgressionStepBillingValues draft_in_review = 3;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.getDraftInReview = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.setDraftInReview = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.clearDraftInReview = function() {
  return this.setDraftInReview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.hasDraftInReview = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ProgressionStepBillingValues draft_rejected = 4;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.getDraftRejected = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 4));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.setDraftRejected = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.clearDraftRejected = function() {
  return this.setDraftRejected(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.hasDraftRejected = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ProgressionStepBillingValues draft_approved = 5;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.getDraftApproved = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.setDraftApproved = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.clearDraftApproved = function() {
  return this.setDraftApproved(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.hasDraftApproved = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ProgressionStepBillingValues authorization_signed = 6;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.getAuthorizationSigned = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 6));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.setAuthorizationSigned = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.clearAuthorizationSigned = function() {
  return this.setAuthorizationSigned(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.hasAuthorizationSigned = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ProgressionStepBillingValues return_filed = 7;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.getReturnFiled = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 7));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.setReturnFiled = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionRetail} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.clearReturnFiled = function() {
  return this.setReturnFiled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionRetail.prototype.hasReturnFiled = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionEssential} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobStarted: (f = msg.getJobStarted()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    deliverableCompleted: (f = msg.getDeliverableCompleted()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionEssential}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemJobProgressionEssential;
  return proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionEssential} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionEssential}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setJobStarted(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setDeliverableCompleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionEssential} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobStarted();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getDeliverableCompleted();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProgressionStepBillingValues job_started = 1;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.prototype.getJobStarted = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionEssential} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.prototype.setJobStarted = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionEssential} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.prototype.clearJobStarted = function() {
  return this.setJobStarted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.prototype.hasJobStarted = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ProgressionStepBillingValues deliverable_completed = 2;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.prototype.getDeliverableCompleted = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionEssential} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.prototype.setDeliverableCompleted = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionEssential} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.prototype.clearDeliverableCompleted = function() {
  return this.setDeliverableCompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionEssential.prototype.hasDeliverableCompleted = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobStarted: (f = msg.getJobStarted()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    openItems: (f = msg.getOpenItems()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    preparationCompleted: (f = msg.getPreparationCompleted()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation;
  return proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setJobStarted(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setOpenItems(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setPreparationCompleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobStarted();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getOpenItems();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getPreparationCompleted();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProgressionStepBillingValues job_started = 1;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.getJobStarted = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.setJobStarted = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.clearJobStarted = function() {
  return this.setJobStarted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.hasJobStarted = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ProgressionStepBillingValues open_items = 2;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.getOpenItems = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.setOpenItems = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.clearOpenItems = function() {
  return this.setOpenItems(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.hasOpenItems = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ProgressionStepBillingValues preparation_completed = 3;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.getPreparationCompleted = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.setPreparationCompleted = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.clearPreparationCompleted = function() {
  return this.setPreparationCompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionPreparation.prototype.hasPreparationCompleted = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InventoryItemJobProgressionReview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobStarted: (f = msg.getJobStarted()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    openItems: (f = msg.getOpenItems()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    draftInReview: (f = msg.getDraftInReview()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    draftRejected: (f = msg.getDraftRejected()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    draftApproved: (f = msg.getDraftApproved()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f),
    reviewCompleted: (f = msg.getReviewCompleted()) && proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InventoryItemJobProgressionReview;
  return proto.worklayer.internal.v1.InventoryItemJobProgressionReview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setJobStarted(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setOpenItems(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setDraftInReview(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setDraftRejected(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setDraftApproved(value);
      break;
    case 6:
      var value = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader);
      msg.setReviewCompleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InventoryItemJobProgressionReview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobStarted();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getOpenItems();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getDraftInReview();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getDraftRejected();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getDraftApproved();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
  f = message.getReviewCompleted();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProgressionStepBillingValues job_started = 1;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.getJobStarted = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.setJobStarted = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.clearJobStarted = function() {
  return this.setJobStarted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.hasJobStarted = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ProgressionStepBillingValues open_items = 2;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.getOpenItems = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.setOpenItems = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.clearOpenItems = function() {
  return this.setOpenItems(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.hasOpenItems = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ProgressionStepBillingValues draft_in_review = 3;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.getDraftInReview = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.setDraftInReview = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.clearDraftInReview = function() {
  return this.setDraftInReview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.hasDraftInReview = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ProgressionStepBillingValues draft_rejected = 4;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.getDraftRejected = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 4));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.setDraftRejected = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.clearDraftRejected = function() {
  return this.setDraftRejected(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.hasDraftRejected = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ProgressionStepBillingValues draft_approved = 5;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.getDraftApproved = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.setDraftApproved = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.clearDraftApproved = function() {
  return this.setDraftApproved(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.hasDraftApproved = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ProgressionStepBillingValues review_completed = 6;
 * @return {?proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.getReviewCompleted = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionStepBillingValues} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionStepBillingValues, 6));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionStepBillingValues|undefined} value
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} returns this
*/
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.setReviewCompleted = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InventoryItemJobProgressionReview} returns this
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.clearReviewCompleted = function() {
  return this.setReviewCompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InventoryItemJobProgressionReview.prototype.hasReviewCompleted = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProgressionStepBillingValues.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProgressionStepBillingValues} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProgressionStepBillingValues.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientChargeAmount: (f = msg.getClientChargeAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    proPayoutAmount: (f = msg.getProPayoutAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProgressionStepBillingValues;
  return proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProgressionStepBillingValues} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProgressionStepBillingValues}
 */
proto.worklayer.internal.v1.ProgressionStepBillingValues.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setClientChargeAmount(value);
      break;
    case 2:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProPayoutAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProgressionStepBillingValues.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProgressionStepBillingValues} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProgressionStepBillingValues.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientChargeAmount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getProPayoutAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional worklayer.shared.types.v1.Decimal client_charge_amount = 1;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.ProgressionStepBillingValues.prototype.getClientChargeAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 1));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.ProgressionStepBillingValues} returns this
*/
proto.worklayer.internal.v1.ProgressionStepBillingValues.prototype.setClientChargeAmount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.ProgressionStepBillingValues} returns this
 */
proto.worklayer.internal.v1.ProgressionStepBillingValues.prototype.clearClientChargeAmount = function() {
  return this.setClientChargeAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.ProgressionStepBillingValues.prototype.hasClientChargeAmount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal pro_payout_amount = 2;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.ProgressionStepBillingValues.prototype.getProPayoutAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 2));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.ProgressionStepBillingValues} returns this
*/
proto.worklayer.internal.v1.ProgressionStepBillingValues.prototype.setProPayoutAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.ProgressionStepBillingValues} returns this
 */
proto.worklayer.internal.v1.ProgressionStepBillingValues.prototype.clearProPayoutAmount = function() {
  return this.setProPayoutAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.ProgressionStepBillingValues.prototype.hasProPayoutAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.GetManyInventoryItemsErrorType = {
  INVENTORY_ITEM_ACCESS_DENIED: 0,
  INVENTORY_ITEM_NOT_FOUND: 1
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.InventoryItemPriceType = {
  FLAT: 0,
  FEE: 1,
  MARKUP: 2,
  MARKDOWN: 3
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.InventoryItemProVisibility = {
  HIDDEN: 0,
  VISIBLE: 1
};

goog.object.extend(exports, proto.worklayer.internal.v1);
